import { render, staticRenderFns } from "./supplier-form.vue?vue&type=template&id=df99e1b8&"
import script from "./supplier-form.vue?vue&type=script&lang=ts&"
export * from "./supplier-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports